import api from "../../config/client.axios.api";

export const deleteMachineApi = async (userId: any) => {
  const response = await api.delete(`/machine`, {
    params: {
      userId,
    },
  });
  return response.data;
};
